import axios from '../../api/diagnosisAPI';
import { setErrorNotification } from '../snackbarNotification';

export const FETCH_BEGIN = 'symptomLocation.list/FETCH_BEGIN';
export const FETCH_SUCCESS = 'symptomLocation.list/FETCH_SUCCESS';
export const FETCH_FAILED = 'symptomLocation.list/FETCH_FAILED';

const fetchBegin = () => ({ type: FETCH_BEGIN });
const fetchSuccess = data => ({ type: FETCH_SUCCESS, payload: data });
const fetchFailed = error => ({ type: FETCH_FAILED, payload: error });
export const fetchSymptomLocationList = () => async dispatch => {
  dispatch(fetchBegin());

  try {
    const res = await axios.get('retrieve-anatomy');

    dispatch(fetchSuccess(res.data.result));
  } catch (error) {
    dispatch(fetchFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_BEGIN:
      return { ...state, error: null };
    case FETCH_SUCCESS:
      return { ...state, data: payload };
    case FETCH_FAILED:
      return { ...state, error: payload };

    default:
      return state;
  }
};

const DUMMY_LOCATION = [
  { id: 'HEAD', name: 'HEAD' },
  { id: 'BACK', name: 'BACK' },
  { id: 'BELLY', name: 'BELLY' },
  { id: 'FRONT LEG', name: 'FRONT LEG' },
  { id: 'HIND LEG', name: 'HIND LEG' },
  { id: 'TAIL', name: 'TAIL' }
];

const initialState = {
  data: [],
  error: null
};
